import React from "react";

const TicketItem = (props) => {
  const {
    ticket: { amount, category, name, ticket_level_id },
    decrementTickets,
    incrementTickets,
    removeTicket,
    setTickets,
    tickets,
  } = props;

  return (
    <div className="row">
      <div className="col-xs-12">
        <label className="event-ticket-label" htmlFor="event_register_form_num_tickets">
          {name} tickets
        </label>
      </div>
      <div className="col-xs-5">
        <div>Quantity</div>
        <span className="event-ticket-box">
          <i onClick={decrementTickets} className="fa fa-minus less"></i>
          <input
            className="ticket-amt"
            type="number"
            id="event_register_form_num_tickets"
            min="1"
            name="event_register_form[num_tickets]"
            onChange={setTickets}
            value={tickets}
          />
          <i onClick={incrementTickets} className="fa fa-plus more"></i>
        </span>
      </div>
      <div className="col-xs-3 text-center">
        <div>Price</div>
        <span className="event-ticket-calc">{amount || 0}</span>
      </div>
      <div className="col-xs-4 text-center">
        <i
          className="fa fa-2x fa-trash pointer m-md-t"
          onClick={() => removeTicket(ticket_level_id)}></i>
      </div>
    </div>
  );
};

export default TicketItem;
